// extracted by mini-css-extract-plugin
module.exports = {"aboutusMainPage":"Aboutus_aboutusMainPage__mQL49"};